import ProductListValues from './productlistvalues.js';

/**
 * Shared values and functions for the product listing page.
 * @type {ProductListValues}
 * @returns {ProductListValues} An instance of the ProductListValues class containing shared values for the product listing page.
 */
export const prodListValues = new ProductListValues(
    document.getElementById('ItemsPerPage').value,
    document.getElementById('isUserRegistered').value
);